import {
    useTopMenuStore,
    useUiLayoutStore,
} from '@frontend/stores'
import clsx from 'clsx'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {CabinetButtons} from './CabinetButtons'
import {PublicLinks} from './PublicLinks'
import {TopNavigationLogo} from './TopNavigationLogo'

// Верхнее меню навигации для больших экранов (Bootstrap xl+).
export function TopNavigationContent() {

    const bootstrapSize = useUiLayoutStore(
        state => state.bootstrapSize
    )

    const deviceType = useUiLayoutStore(
        state => state.deviceType
    )

    const cabinetMode = useTopMenuStore(
        state => state.cabinetMode
    )

    return (
        <div
            className={clsx(
                'inner-container flex-row-between align-items-center',
                cabinetMode ? 'cabinet-mode' : 'public-mode'
            )}
        >
            <div className="flex-row-center justify-content-start flex-1">
                <TopNavigationLogo
                    short={bootstrapSize === 'xxs' || bootstrapSize === 'xs'} // на sm+ - полный
                />
                {(deviceType === 'desktop' || bootstrapSize === 'lg') && (
                    <Collapse
                        show={!cabinetMode}
                        horizontal
                    >
                        <PublicLinks />
                    </Collapse>
                )}
            </div>
            <CabinetButtons />
        </div>
    )
}
